/* eslint-disable */
export const SET_OPEN_SMALL_SCREEN_NAV = 'SET_OPEN_SMALL_SCREEN_NAV'
export const SET_URL_PREFIX = 'SET_URL_PREFIX'
export const SET_MAIN_DIALOG_DATAS = 'SET_MAIN_DIALOG_DATAS'
export const SET_MAIN_DIALOG_COUNT = 'SET_MAIN_DIALOG_COUNT'
export const SET_VARIABLES = 'SET_VARIABLES'
export const SET_CHEMINS = 'SET_CHEMINS'
